import { HttpParams } from '@angular/common/http';
import { GetDepartmentsValue } from './get-departments.value';

export class GetDepartmentsValueDto {
    page: number;
    limit: number;
    divisionIds: string[];

    constructor(data: GetDepartmentsValue) {
        this.page = data.page;
        this.limit = data.limit;
        this.divisionIds = data.divisionIds;
    }

    toHttpParams(): HttpParams {
        return new HttpParams().set('page', this.page).set('limit', this.limit).appendAll({ 'divisionId[]': this.divisionIds });
    }
}
